// extracted by mini-css-extract-plugin
export default {"leftNav":"HamburgerMenu_leftNav__WFpL5"};